/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { ApprovalRowService } from './services/approval-row.service';
import { AuthService } from './services/auth.service';
import { BumpsDetailService } from './services/bumps-detail.service';
import { CompanyService } from './services/company.service';
import { ConstantsService } from './services/constants.service';
import { DetailsOfDefectService } from './services/details-of-defect.service';
import { FileService } from './services/file.service';
import { FileTemplateService } from './services/file-template.service';
import { InspectorAuditReportService } from './services/inspector-audit-report.service';
import { ManagementAndControlPlanService } from './services/management-and-control-plan.service';
import { ProcessService } from './services/process.service';
import { ProjectService } from './services/project.service';
import { ProjectEmployeeService } from './services/project-employee.service';
import { SafetyAppendixService } from './services/safety-appendix.service';
import { SafetyConsultantDefectService } from './services/safety-consultant-defect.service';
import { SafetyConsultantDefectRecordService } from './services/safety-consultant-defect-record.service';
import { SafetyConsultantPeriodicReportService } from './services/safety-consultant-periodic-report.service';
import { SafetyIncidentReportService } from './services/safety-incident-report.service';
import { SafetyOfficerPeriodicReportService } from './services/safety-officer-periodic-report.service';
import { SafetyPlanService } from './services/safety-plan.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    ApprovalRowService,
    AuthService,
    BumpsDetailService,
    CompanyService,
    ConstantsService,
    DetailsOfDefectService,
    FileService,
    FileTemplateService,
    InspectorAuditReportService,
    ManagementAndControlPlanService,
    ProcessService,
    ProjectService,
    ProjectEmployeeService,
    SafetyAppendixService,
    SafetyConsultantDefectService,
    SafetyConsultantDefectRecordService,
    SafetyConsultantPeriodicReportService,
    SafetyIncidentReportService,
    SafetyOfficerPeriodicReportService,
    SafetyPlanService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
